import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'reason',
        'reasonText',
        'invalidReason',
    ];

    initialize() {
        this.reasonOnChange.bind(this);
    }
    reasonOnChange() {
        if ('manage_booking.cancel_reason.Others' === this.reasonTarget.value) {
            $(this.reasonTextTarget).closest('.form-group').show().children().removeClass('d-none');
        } else {
            $(this.reasonTextTarget).closest('.form-group').hide();
        }

        if (this.reasonTarget.value) {
            this.reasonTarget.classList.remove('is-invalid');
        } else {
            this.reasonTarget.classList.add('is-invalid');
        }
    }

    reasonTextOnChange() {
        if (this.reasonTextTarget.value) {
            this.reasonTextTarget.classList.remove('is-invalid');
        } else {
            this.reasonTextTarget.classList.add('is-invalid');
        }
    }

    submitForm(event) {
        event && event.preventDefault();
        showPreloader();
        let hasErrors = false;
        let reasonField = this.reasonTarget;

        if (!reasonField.value) {
            this.invalidReasonTarget.style.removeProperty('display');
            reasonField.classList.add('is-invalid');
            hasErrors = true;
        } else if ('manage_booking.cancel_reason.Others' === this.reasonTarget.value) {
            if (!this.reasonTextTarget.value) {
                this.reasonTextTarget.classList.add('is-invalid');
                hasErrors = true;
            } else {
                this.reasonTextTarget.classList.remove('is-invalid');
            }
        } else {
            this.invalidReasonTarget.style.setProperty('display', 'none');
            reasonField.classList.remove('is-invalid');
        }

        if (hasErrors) {
            hidePreloader();
            return;
        }

        $(event.target).closest('form').submit()
    }
}
